import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CommonSelectTask from '../../../components/tools/CommonSelectTask/CommonSelectTask';
import { getSelectedOrder } from '../../../selectors/tools';
import { setSelectedTask } from '../../../actions/tools/OrdersSearchActions';

const TASK_INPUTS = [
  {
    id: 'orderDetails',
    title: 'Order Summary',
  },
];

const mapStateToProps = (state) => {
  const selectedOrder = getSelectedOrder(state);
  const taskInputsToShow = TASK_INPUTS.filter((taskInput) => {
    return taskInput.conditionFunc ? taskInput.conditionFunc(selectedOrder, state) : true;
  });

  return {
    taskInputs: taskInputsToShow,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setSelectedTask,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonSelectTask);
